import { Controller } from '@hotwired/stimulus'
import Cookies from 'js-cookie'

export default class extends Controller {
  static targets = ['inquiryButton']

  checkFacilityCount () {
    if (this.facilityCount() > 20) {
      alert('21件以上は、まとめてお問い合わせできません')
    } else {
      window.location.href = this.newUrl()
    }
  }

  facilityCount () {
    return this.facilityIds().length
  }

  facilityIds () {
    return JSON.parse(Cookies.get('check_nursing_facility_ids') || '[]')
  }

  newUrl () {
    const url = new URL(this.baseUrl())
    const params = url.searchParams
    for (const id of this.facilityIds()) {
      params.append('facility_ids[]', id)
    }
    url.search = params.toString()
    return url.toString()
  }

  baseUrl () {
    return this.element.dataset.url
  }
}
